
<div class="auth-shell">
  <!-- Sidebar -->
  <div class="auth-sidebar">
    <div class="logo-row">
      <div class="logo-text">
        <img src="assets/images/Rondeivu-white-logo.png" style="height: 46px;">
        <span style="font-size: 28px; height: 46px; line-height: 46px; margin-bottom: 6px;">{{appEnvironment}}</span>
      </div>
    </div>
        <div class="auth-sidebar-body">
      <!-- <div class="serif-q">The platform where<br>capital meets<br><em>opportunity.</em></div> -->
      <div class="serif-q">The lifecycle operating<br>system for<br><em>private markets.</em></div>
      <div class="auth-sidebar-stats">
        <div><div class="stat-n">$374B</div><div class="stat-d">Total Mandates</div></div>
        <div><div class="stat-n">$3.4B</div><div class="stat-d">Total Deal Volume</div></div>
        <div><div class="stat-n"><a class="stat-n" target="_blank" style="text-decoration: none;" href="https://finra.org">FINRA</a></div><div class="stat-d">Member Broker Dealer</div></div>
        <div><div class="stat-n">OSC</div><div class="stat-d">Exempt Market Dealer</div></div>
      </div>
      <div class="mt-4">
        <em style="font-size: smaller">As of Sept 30, 2026</em>
      </div>
    </div>
    <div class="auth-sidebar-foot">354 Pequot Ave, Southport CT 06890<br>1 Adelaide St E, Suite 3001, Toronto ON<br>info@rondeivu.com · &copy; {{currentYear}} Rondeivu, Inc.</div>
  </div>

  <!-- Content -->
  <div class="mini-logo">
    <div class="logo-text">
      <img src="assets/images/Rondeivu-white-logo.png">
      <span style="font-size: 28px; height: 46px; line-height: 46px; margin-bottom: 6px;">{{appEnvironment}}</span>
    </div>
  </div>
  <div class="auth-main">
    <router-outlet></router-outlet>
  </div>
</div>
